import { RuntimeEnvironment } from '@/environment/runtime-environment';

interface BackendGraphqlFetchOptions {
  cache?: RequestCache;
  next?: NextFetchRequestConfig;
}

type BackendGraphqlFetchStrategy
  = | 'NO_CACHE'
    | 'FORCE_CACHE_10MIN'
    | 'FORCE_CACHE_1H'
    | 'FORCE_CACHE_1D'
  ;

const BackendGraphqlFetchStrategyValues: Record<BackendGraphqlFetchStrategy, BackendGraphqlFetchOptions> = {
  NO_CACHE: {
    cache: 'no-cache',
    next: { revalidate: 0 },
  },
  FORCE_CACHE_10MIN: {
    cache: 'force-cache',
    next: { revalidate: 600 },
  },
  FORCE_CACHE_1H: {
    cache: 'force-cache',
    next: { revalidate: 3600 },
  },
  FORCE_CACHE_1D: {
    cache: 'force-cache',
    next: { revalidate: 86400 },
  },
};

export interface BackendGraphqlApiConfig {
  baseUrl: string;
  fetchOptions: BackendGraphqlFetchOptions;
}

export const MedprevBackendGraphqlApiConfig: Record<string, BackendGraphqlApiConfig> = {
  LOCAL: {
    baseUrl: process.env.NEXT_PUBLIC_GRAPHQL_API_BASE_URL ?? 'http://localhost:4000',
    fetchOptions: BackendGraphqlFetchStrategyValues.NO_CACHE,
  },
  TEST: {
    baseUrl: 'https://alpha.medprev.online/graphql',
    fetchOptions: BackendGraphqlFetchStrategyValues.NO_CACHE,
  },
  HML: {
    baseUrl: 'https://beta.medprev.online/graphql',
    fetchOptions: BackendGraphqlFetchStrategyValues.NO_CACHE,
  },
  PRD: {
    baseUrl: 'https://medprev.online/graphql',
    fetchOptions: BackendGraphqlFetchStrategyValues.FORCE_CACHE_1D,
  },
};

export function getBackendGraphqlApiConfig(env?: RuntimeEnvironment): BackendGraphqlApiConfig {
  switch (env) {
    case RuntimeEnvironment.LOCAL:
      return MedprevBackendGraphqlApiConfig.LOCAL;
    case RuntimeEnvironment.TEST:
      return MedprevBackendGraphqlApiConfig.TEST;
    case RuntimeEnvironment.HML:
      return MedprevBackendGraphqlApiConfig.HML;
    case RuntimeEnvironment.PRD:
      return MedprevBackendGraphqlApiConfig.PRD;
    default:
      return {
        baseUrl: process.env.NEXT_PUBLIC_GRAPHQL_API_BASE_URL ?? '',
        fetchOptions: BackendGraphqlFetchStrategyValues.NO_CACHE,
      };
  }
}
